import { primaryButton } from "../../../components/ui/buttonStyles.js";
import { Ico } from "../../../components/icons/icons.jsx";
import { FilterRow } from "../components/FilterRow.jsx";
import { rbSectionHint } from "../reportBuilderTheme.js";

function LogicToggle({ value, onChange, c, A }) {
  return (
    <div style={{ display: "inline-flex", borderRadius: 8, border: `1px solid ${c.cardBdr}`, overflow: "hidden" }}>
      {["and", "or"].map((mode) => {
        const active = value === mode;
        return (
          <button
            key={mode}
            type="button"
            onClick={() => onChange(mode)}
            style={{
              padding: "6px 14px",
              border: "none",
              background: active ? A : c.card,
              color: active ? "#fff" : c.mid,
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
              textTransform: "uppercase",
            }}
          >
            {mode}
          </button>
        );
      })}
    </div>
  );
}

export function FiltersStep({ filters, filterLogic, fields, onAdd, onUpdate, onRemove, onLogicChange, c, A, dark }) {
  const complete = filters.filter((f) => f.field && f.value).length;

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 8 }}>
        <p style={{ ...rbSectionHint(c), margin: 0, flex: 1 }}>
          Add predicates to narrow the scan. Filters update the cost estimate immediately.
        </p>
        {filters.length > 1 ? <LogicToggle value={filterLogic} onChange={onLogicChange} c={c} A={A} /> : null}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 12 }}>
        {filters.length === 0 ? (
          <div
            style={{
              padding: "20px 16px",
              borderRadius: 10,
              border: `1px dashed ${c.cardBdr}`,
              textAlign: "center",
              color: c.sub,
              fontSize: 12,
            }}
          >
            No filters — all rows in the dataset will be scanned.
          </div>
        ) : (
          filters.map((f, i) => (
            <FilterRow
              key={f.id}
              filter={f}
              index={i}
              logic={filterLogic}
              fields={fields}
              onChange={(patch) => onUpdate(f.id, patch)}
              onRemove={() => onRemove(f.id)}
              c={c}
              A={A}
            />
          ))
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
        <button type="button" onClick={onAdd} style={primaryButton(A, { dark, height: 34, fontSize: 12 })}>
          {Ico.plus}
          Add filter
        </button>
        {filters.length > 0 ? (
          <span style={{ fontSize: 11, color: c.sub }}>
            {complete} of {filters.length} complete
          </span>
        ) : null}
      </div>
    </div>
  );
}
